export function filterObjectKeys<T>(object: object, excludeKeys: (keyof T)[]): string[] {
  return Object.keys(object).filter((key) => !excludeKeys.includes(key as keyof T));
}
